// import consts
import { CACHEBUST, BASE_URL, ASSET_URL } from 'js/constants/App';
// import utils
import { convertFileExtensionToWebp } from 'js/utils/general';

export const staticAssets = (asset) => {
  if (JW_WATCH) {
    const { VITE_WATCH_PROTOCOL = 'https', VITE_WATCH_HOST = 'localhost', VITE_WATCH_PORT = 3000 } = import.meta.env;
    const FRONTEND_WATCH_URL = `${VITE_WATCH_PROTOCOL}://${VITE_WATCH_HOST}:${VITE_WATCH_PORT}`;
    return `${FRONTEND_WATCH_URL}/${asset}`;
  }

  return `${ASSET_URL}${asset}${CACHEBUST}`;
};

export const staticImageAssets = (img) => {
  if (JW_WATCH) {
    const { VITE_WATCH_PROTOCOL = 'https', VITE_WATCH_HOST = 'localhost', VITE_WATCH_PORT = 3000 } = import.meta.env;
    const FRONTEND_WATCH_URL = `${VITE_WATCH_PROTOCOL}://${VITE_WATCH_HOST}:${VITE_WATCH_PORT}`;
    return `${FRONTEND_WATCH_URL}/${img}`;
  }

  return `${ASSET_URL}${convertFileExtensionToWebp(img)}${CACHEBUST}`;
};

export const dynamicAssets = (img, convertToWebp = false) => {
  if (JW_WATCH) {
    img = img.replace('http://127.0.0.1:8000/storage', 'https://localhost/BLUMICRO/storage/app/public');
  }

  if (convertToWebp) {
    return `${convertFileExtensionToWebp(img)}`;
  } else {
    return img;
  }
};
